// src/utils/IntelNormalizer.js
import { normalizeSectorName } from "./normalizeSectorName";

export function normalizeIntelKeys(intel) {
  const out = {};
  const isDev = import.meta.env.DEV;

  if (!intel || typeof intel !== "object") return out;

  for (const [rawKey, value] of Object.entries(intel)) {
    const cleaned = typeof rawKey === "string" ? rawKey.trim() : rawKey;
    const norm = normalizeSectorName(cleaned);

    if (!norm) {
      if (isDev) {
        console.warn("[IntelNormalizer] Dropping invalid intel key:", rawKey);
      }
      continue;
    }

    if (out[norm] && isDev) {
      console.warn(
        `[IntelNormalizer] Duplicate normalized key '${norm}' from raw key '${rawKey}'`
      );
    }

    out[norm] = value;
  }

  return out;
}
